import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-ink text-white py-12 px-6 md:px-12" data-id="element-77">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-78">
        <img src="https://cdn.magicpatterns.com/uploads/c9sWKrnv1vxYm1ZPgVh9dm/ChatGPT_Image_May_13,_2026,_09_40_06_PM.png" alt="Year One Mentor" className="h-[60px] w-auto rounded" data-id="element-79" />

        <div className="flex gap-6 text-sm text-mist/60" data-id="element-80">
          <Link to="/#coaching" className="hover:text-white transition-colors" data-id="element-81">
            Coaching
          </Link>
          <Link to="/#programs" className="hover:text-white transition-colors" data-id="element-82">
            Programs
          </Link>
          <Link to="/#resources" className="hover:text-white transition-colors" data-id="element-83">
            Resources
          </Link>
          <Link to="/about" className="hover:text-white transition-colors" data-id="element-84">
            About
          </Link>
        </div>

        <div className="text-sm text-mist/40" data-id="element-85">
          &copy; {new Date().getFullYear()} Year One Mentor. All rights
          reserved.
        </div>
      </div>
    </footer>;
}